import axios from "axios";

const api = axios.create({
  // baseURL: 'https://registronacionalapi.lais.ufrn.br/registro',
  //baseURL: 'http://localhost:8000/registro/',
  baseURL: "https://registronacionalapi.homolog.lais.ufrn.br/registro/",
  headers: {
    Authorization: `token ${process.env.REACT_APP_TOKEN_REGISTRO_API}`,
  },
});

export async function getDadosRegistro(identificador) {
  try {
    const { data } = await api.get(`?identificador=${identificador}`);
    return data;
  } catch (error) {
    console.error("Ocorreu um erro:", error.message);
  }
}

export async function getDadosRegistroPorCPF(cpf) {
  try {
    const { data } = await api.get(`?cpf=${cpf}`);
    return data;
  } catch (error) {
    console.error("Ocorreu um erro:", error.message);
  }
}
